import { createTheme, createVariant } from '@clds/component-theme';
export const progressTheme = createTheme({
    spinnerVariant: {
        thin: 8,
        thick: 2.5,
    },
});
export const spinnerVariant = createVariant((props) => 
// eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
progressTheme.spinnerVariant[props.spinnerVariant || 'thin']);
//# sourceMappingURL=theme.js.map